const formatAmount = value => {
  return parseFloat(value || 0)
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export default formatAmount;
